import {Match} from '../resources/Match';
import {EntityExportAvailableEvent} from './EntityExportAvailableEvent';

/**
 * This event can be fired to indicate that some data as requested via the {@see MatchesExportRequested} event is
 * available and can be processed.
 */
export class MatchesExportAvailable extends EntityExportAvailableEvent<Match> {
}
